import AddSkill from "../../Components/Modals/AddSkill";
import Table from "../../Components/Table";
import { deleteSkillById, getSkill } from "../../Services/SkillService";

const Skill = () => {
    const columns = [
        {
            label: "Skill",
            value: "name"
        },
        {
            label: "Status",
            value: "status_name"
        },
        {
            label: "Description",
            value: "description"
        },
        {
            label: "Icon",
            value: "icon",
            renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddSkill data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getSkill}
            columns={columns}
            title={"Skill Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteSkillById}
        />
    );
}

export default Skill;